import { createStructuredSelector } from 'reselect'

const historys = ({ historys }) => historys.getIn(['historysList'], [])
const loading = ({ historys }) => historys.getIn(['loading'], false)

export default createStructuredSelector({
  loading,
  historys
})
